import LOGO from "@/assets/logo.png";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="footer"
      className="bg-anthracite-950 border-t border-gold-500/15 relative overflow-hidden"
    >
      {/* Background watermark */}
      <div className="absolute -bottom-32 -right-32 font-serif text-[20rem] text-white/[0.02] leading-none pointer-events-none select-none">
        N
      </div>

      <div className="max-w-[1500px] mx-auto px-6 md:px-10 lg:px-14 py-16 md:py-20 relative">
        <div className="grid grid-cols-12 gap-10 md:gap-8 items-start">
          {/* Brand */}
          <div className="col-span-12 md:col-span-5">
            <img
              src={LOGO}
              alt="NOBLESSE Massage & Spa"
              data-testid="footer-logo"
              className="h-24 w-auto mb-6"
            />
            <p className="text-cream/55 text-sm font-light leading-relaxed max-w-sm">
              Prémium masszázsélmény Rostás Ibolyával. Diszkrét, figyelmes,
              személyre szabott kezelések Budapesten — a Népstadion környékén.
            </p>
            <div className="mt-6 inline-flex items-center gap-3 text-[10px] uppercase tracking-[0.4em] text-gold-500/70">
              <span>Est. Budapest</span>
              <span className="text-cream/20">·</span>
              <span>MMXXVI</span>
            </div>
          </div>

          {/* Links */}
          <div className="col-span-6 md:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.4em] text-gold-500 mb-6">
              Információk
            </div>
            <ul className="space-y-4 text-sm font-light">
              <li>
                <a
                  href="#aszf"
                  data-testid="footer-aszf"
                  className="text-cream/60 hover:text-gold-500 transition-colors"
                >
                  ÁSZF
                </a>
              </li>
              <li>
                <a
                  href="#privacy"
                  data-testid="footer-privacy"
                  className="text-cream/60 hover:text-gold-500 transition-colors"
                >
                  Adatkezelési tájékoztató
                </a>
              </li>
              <li>
                <a
                  href="#contact"
                  data-testid="footer-contact-link"
                  className="text-cream/60 hover:text-gold-500 transition-colors"
                >
                  Kapcsolat
                </a>
              </li>
              <li>
                <a
                  href="#treatments"
                  className="text-cream/60 hover:text-gold-500 transition-colors"
                >
                  Kezelések
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="col-span-6 md:col-span-4">
            <div className="text-[10px] uppercase tracking-[0.4em] text-gold-500 mb-6">
              Elérhetőség
            </div>
            <ul className="space-y-4 text-sm font-light">
              <li>
                <a
                  href="tel:+36303915392"
                  data-testid="footer-phone"
                  className="font-serif text-xl text-cream hover:text-gold-500 transition-colors tracking-wider"
                >
                  +36 30 391 5392
                </a>
              </li>
              <li>
                <a
                  href="mailto:ibihugo72@gmail.com"
                  data-testid="footer-email"
                  className="text-cream/60 hover:text-gold-500 transition-colors break-all"
                >
                  ibihugo72@gmail.com
                </a>
              </li>
              <li className="text-cream/50 leading-relaxed">
                A Népstadiontól gyalog 2 percre
                <br />
                <span className="text-cream/30">Budapest</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-[10px] uppercase tracking-[0.35em] text-cream/35 font-light">
            © {year} NOBLESSE Massage & Spa — Rostás Ibolya
          </div>
          <div className="text-[10px] uppercase tracking-[0.4em] text-cream/25">
            Minden jog fenntartva
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
